export default "__VITE_PUBLIC_ASSET__b509a944__"